import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    zIndex: 3,
    display: 'flex',
    height: theme.spacing(6.75),
  },

  navigation: {
    bottom: '0',
    width: '100%',
    position: 'fixed',
    height: theme.spacing(6.75),
    background: theme.palette.background.paper,
  },

  content: {
    paddingTop: theme.spacing(7.75),
    position: 'fixed',
    top: 0,
    width: '100%',
    background: theme.palette.background.paper,
    height: `calc(100% - ${theme.spacing(6.75)})`,
    zIndex: 0,
  },
}));
